import { getIn } from "@utils/index"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"

import { FooterProps } from "../common"
import Footer from "../index"

export const FooterLinkDataFields: any = graphql`
  fragment FooterLinkDataFields on ContentfulLink {
    link
    text
    external
    openNewTab
  }
`

const withContentfulData: any =
  (WrappedComponent: any) => (props: FooterProps) => {
    const data = useStaticQuery(graphql`
      query FooterDataFields {
        contentfulGlobalSettings(internalTitle: { eq: "uag global settings" }) {
          footerShopLabelLink {
            ...FooterLinkDataFields
          }
          footerShopLinks {
            ...FooterLinkDataFields
          }
          footerExploreLabelLink {
            ...FooterLinkDataFields
          }
          footerExploreLinks {
            ...FooterLinkDataFields
          }
          footerExploreLinksMobile {
            ...FooterLinkDataFields
          }
          footerBusinessLabelLink {
            ...FooterLinkDataFields
          }
          footerBusinessLinks {
            ...FooterLinkDataFields
          }
          footerSupportLabelLink {
            ...FooterLinkDataFields
          }
          footerSupportLinks {
            ...FooterLinkDataFields
          }
          socialLinks {
            facebook
            instagram
            twitter
            youtube
          }
          legalLinks {
            limitationsOfLiability
            privacyPolicy
            termsAndConditions
          }
        }
      }
    `)

    const footerData: FooterProps = {
      ...props,
      ...getIn(data, "contentfulGlobalSettings", {}),
    }

    return <WrappedComponent {...footerData} />
  }

export default withContentfulData(Footer) as any
